import { S3_HOST } from "@/_constant";
import { useLanguageContext } from "@/hooks";
import { Feature } from "@/types";

interface OnboardingFeatureProps {
    feature: Feature
};

export const OnboardingFeature: React.FC<OnboardingFeatureProps> = ({ feature }) => {
    const { language } = useLanguageContext();

    return (
        <div className="card shadow-none rounded-top-3 h-100">
            <div className="position-relative">
                <img src={S3_HOST + feature.image} className="card-img-top" style={{ "objectFit": "cover", height: "8rem" }} />
                <div className="position-absolute bottom-0">
                    <div className="fs-7 kg-bg-light px-2 py-1">{language(feature.title)}</div>
                </div>
            </div>
            <div className="card-body mt-n1 h-100">
                <p className="fs-7 overflow-hidden">{language(feature.description)}</p>
            </div>
        </div>
    );
}